import React, { useEffect, useState } from "react";
import { customStatuses } from "../../utils/customStatuses";
import { Loader } from "lucide-react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { FaTimes } from "react-icons/fa";

interface RandomStatusProps {
    setAddPostOverlay?: (value: boolean) => void;
}

const RandomStatus: React.FC<RandomStatusProps> = ({ setAddPostOverlay }) => {
    const [customStatus, setCustomStatus] = useState<string>("");

    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        let timer: ReturnType<typeof setTimeout>;

        const updateStatus = () => {
            // Pick a random status from our list
            const randomIndex = Math.floor(
                Math.random() * customStatuses.length
            );
            setCustomStatus(customStatuses[randomIndex]);

            // Set a random delay between 1.5 and 3 seconds before updating again
            const randomDelay =
                Math.floor(Math.random() * (3000 - 1500 + 1)) + 1500;
            timer = setTimeout(updateStatus, randomDelay);
        };

        updateStatus();

        return () => {
            clearTimeout(timer);
            document.body.style.overflow = originalOverflow;
        };
    }, []);

    const isMobile = useIsMobile(700);

    return (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 top-16">
            <div
                className={`relative h-fit ${
                    isMobile ? "w-full max-w-md" : "w-1/3"
                } rounded-lg bg-white p-6 shadow-lg z-50 border border-primary `}
            >
                {setAddPostOverlay && (
                    <FaTimes
                        className={`absolute right-4 top-4 text-gray-500 hover:text-gray-700 cursor-pointer`}
                        onClick={() => setAddPostOverlay(false)}
                        style={{}}
                    />
                )}
                <div className="h-full w-full text-primary flex items-center justify-center">
                    <dt className="flex items-center justify-center font-semibold text-lg">
                        <Loader className="mr-2 h-7 w-7 animate-spin text-secondary" />
                        {customStatus}
                    </dt>
                </div>
            </div>
        </div>
    );
};

export default RandomStatus;
